var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconAstronaut3 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 5.188V4.25a3.281 3.281 0 1 0-6.562 0v.938m6.562 0c0 1.294-1.47 2.732-3.281 2.732S4.687 6.482 4.687 5.188m6.563 0c0-1.295-1.469-2.344-3.281-2.344s-3.282 1.05-3.282 2.344M1.876 15.03a6.094 6.094 0 0 1 12.188 0M5.155 12.14H7.03m-1.875 1.875H7.03M4.75 5.656h-.062a1.875 1.875 0 0 0-1.875 1.875v4.25m10.312 0v-4.25a1.875 1.875 0 0 0-1.875-1.874h-.066m-1.107 6.482a1.172 1.172 0 1 0 .001.002z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 5.188V4.25a3.281 3.281 0 1 0-6.562 0v.938m6.562 0c0 1.294-1.47 2.732-3.281 2.732S4.687 6.482 4.687 5.188m6.563 0c0-1.295-1.469-2.344-3.281-2.344s-3.282 1.05-3.282 2.344M1.876 15.03a6.094 6.094 0 0 1 12.188 0M5.155 12.14H7.03m-1.875 1.875H7.03M4.75 5.656h-.062a1.875 1.875 0 0 0-1.875 1.875v4.25m10.312 0v-4.25a1.875 1.875 0 0 0-1.875-1.874h-.066m-1.107 6.482a1.172 1.172 0 1 0 .001.002z"
  }));
});
export default SvgIconAstronaut3;
export const raw = __webpack_public_path__ + "static/media/IconAstronaut3.fdfbfd56cc7842a053cdc8814fcb2207.svg";